var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-64 md:h-full md:min-h-64 rounded overflow-hidden"},[(_vm.mapsPermitted == 1)?[_c('GmapMap',{staticClass:"rounded-xl w-full h-full relative",attrs:{"center":{ lat: _vm.lat, lng: _vm.lng },"zoom":13,"options":{
        zoomControl: true,
        scrollwheel: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
      },"map-type-id":"terrain"}},[_c('gmap-custom-marker',{attrs:{"marker":{ lat: _vm.lat, lng: _vm.lng }}},[_c('div',{staticClass:"w-4 h-4 bg-brand-blue rounded-full map-maker"})])],1)]:[_c('div',{staticClass:"w-full h-full bg-light-gray flex justify-center items-center"},[_c('button',{staticClass:"link cursor-pointer p-4",on:{"click":function($event){$event.preventDefault();return _vm.enableGoogleMaps.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.labels.googleMapsPermission))])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }